import React from 'react';
import { cn } from '@/lib/utils';

interface BossQuestionProps {
    label?: string;
    className?: string;
}

export default function BossQuestion({ label = '⚔️ Boss Level', className }: BossQuestionProps) {
    return (
        <span
            className={cn(
                'bg-game-warning text-game-bg text-[0.65rem] font-heading font-black uppercase tracking-widest px-2.5 py-1 rounded-full shadow-[0_0_16px_rgba(245,158,11,0.35)]',
                className
            )}
        >
            {label}
        </span>
    );
}
